import React from 'react';
import { Mail } from 'lucide-react';
import { footer } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#0E3A5F] text-white py-12">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 items-center">
            {/* Logo and Tagline */}
            <div className="text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
                <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Top layer - Green */}
                  <rect x="8" y="8" width="20" height="6" rx="1.5" fill="#7AC943"/>
                  {/* Middle layer - Blue */}
                  <rect x="6" y="16" width="24" height="6" rx="1.5" fill="#1F6FB2"/>
                  {/* Bottom layer - Light Blue */}
                  <rect x="4" y="24" width="28" height="6" rx="1.5" fill="#5BA3D9"/>
                </svg>
                <div>
                  <div className="font-bold text-lg leading-tight text-[#7AC943]">
                    {footer.companyName}
                  </div>
                </div>
              </div>
              <p className="text-white/80 text-sm italic">
                "{footer.tagline}"
              </p>
            </div>

            {/* Contact */}
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 text-white/90 hover:text-[#7AC943] transition-colors duration-200">
                <Mail className="h-5 w-5" />
                <a href={`mailto:${footer.email}`} className="font-medium">
                  {footer.email}
                </a>
              </div>
            </div>

            {/* Copyright */}
            <div className="text-center md:text-right">
              <p className="text-white/60 text-sm">
                {footer.copyright}
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-white/10 mt-8 pt-6">
            <p className="text-white/50 text-xs text-center mb-3">
              Custom software solutions for businesses ready to own their technology
            </p>
            <p className="text-white/40 text-xs text-center leading-relaxed">
              {footer.disclaimer}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
